import React, { Component } from 'react';
import _ from 'lodash';
import { trackWindowScroll } from 'react-lazy-load-image-component';

import Product from '../Product';
import * as uri from '../../config/uri';
import { connect } from 'react-redux';
import { setProduct } from '../../actions/product';
import './style.css';
import {isAutoScrollOn} from "../../reducers/autoScrollReducer";
import {
  isLogoAndItemTypeBarFixed as isLogoAndItemTypeBarFixedSelector, 
  isShippingForm as isShippingFormSelector,
  isPhoneSelector,
  isEcommerceSearchBarEnabled
} from "../../selectors/configSelectors";
import {isAddressBarOpened as isAddressBarOpenedSelector} from '../../selectors/address';
import { isSearchPageOpen } from '../../selectors/router_selector';
import {
  isPaymentKiosk as isPaymentKioskSelector, 
  isMainBoard
} from '../../selectors/configSelectors';
import PropTypes from 'prop-types';
import { getColor } from '../../helpers/classification_util';
import { isSearchResult } from '../../helpers/urlParts';
import { getProducts } from '../../selectors/product_selector';
import Filter from "../AdvancedFilter/filter_container";
import EmptyStateGraphic from "../EmptyStateGraphic";
import { getSelectedCustomerType } from "../../selectors/customer_type_selector";
import * as QueryParams from '../../const/query_params';
import { openCloseAdvancedFilter } from '../../reducers/filterReducer';
import { isDesktopAndAdvancedFilterOpen } from '../../selectors/filter_selector';
import { BODY_TEXT_COLOR } from '../../config/colors';
import { scrollTo } from '../../actions/view';
import { pushWithQueryParams } from '../../services/uri';

const MARGIN_TOP_WITH_NO_MARGIN = '0px';
const NO_RESULTS_FOUND = 'No Results Found';

const productMenuStyle = {
  hidden : {
    display: 'none'
  }
}

const emptyStateGraphicStyle = {
  justifyContent: 'center',
  display: 'flex',
  marginTop: 32,
  fontSize: 32,
  width: '100%',
  color: BODY_TEXT_COLOR,
}

class ProductContainerRender extends Component {
  getMarginTop = () => {
    return MARGIN_TOP_WITH_NO_MARGIN;
  };

  render() {
    const {detailView, products, autoScrollEnabled, isPaymentKiosk, selectedCustomerType} = this.props;
    const isDetailView = detailView.isOpen && detailView.viewName === 'PRODUCT_DETAIL';
    const isCartView = detailView.isOpen && detailView.viewName === 'CART_DETAIL';
    let productMenuClass = products.fetching && !autoScrollEnabled ? 'blur' : '';
    productMenuClass += isPaymentKiosk ? ' payment-kiosk-menu ' : '';

    return (
      <div>
        { this.props.isLogo &&
          <div>
            <div className="treez-icon treez-lg" title="TREEZ"></div> 
            <div className="treez-icon treez-sm" title="TREEZ"></div>
          </div>
        }
        <div className="wrapper" style={{position:'relative', marginTop: this.getMarginTop()}}>
          {
            this.props.isEcommerceSearchBarEnabled &&
              this.props.isSearchPage && this.props.queryParams.query && (
                <div style={{display: 'flex', justifyContent: 'center'}}>
                  <div>
                    <h2 className="search-result-title">Result for: "{this.props.queryParams.query}"</h2>
                  </div>
                </div>
            )
          }
          <div style={{ display: 'flex' }}>
            {
              this.props.isAdvancedFilterOpen
                ? (
                  <div style={{margin: '0px 24px'}}>
                    <Filter resetScrollPosition ={this.props.resetScrollPosition} />
                  </div>
                )
                : null
            }
            {
              _.isEmpty(this.props.products.data) && !this.props.fetchingProducts && !this.props.justMadeReq
                ? <EmptyStateGraphic style={emptyStateGraphicStyle} title={NO_RESULTS_FOUND} />
                : !products.changingCategory &&
                <div id="product-menu" className={`product-menu ` + productMenuClass} style={(isDetailView || isCartView) ? productMenuStyle.hidden : {}}>
                  {this.props.products.data.map((product, index) => {
                    const url = `${uri.rootPageUri}category/${product.type.toLowerCase()}/item/${product.categoryId}`;
                    let stateProduct = {...product, index};
                    return (
                      <Product key={index}
                              productIndex={index}
                              menuRoundTax={this.props.menuRoundTax}
                              product={product}
                              url={url}
                              onClick={() => this.props.setCurrentProduct(stateProduct)}
                              colors={this.props.colors}
                              scrollPosition={this.props.scrollPosition}
                      />
                    )
                  })
                }
              </div>
            }
          </div>
        </div>
      </div>
    );
  }
}

ProductContainerRender.propTypes = {
  isShippingForm: PropTypes.bool.isRequired,
  isLogoAndItemTypeBarFixed: PropTypes.bool.isRequired,
  isPaymentKiosk: PropTypes.bool.isRequired,
  isReadOnlyMode: PropTypes.bool.isRequired,
  isSearch: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
  return {
    colors: getColor(state),
    products: getProducts(state),
    detailView: state.detailView,
    isLogo: state.config.NAV_BAR_LOGO !== "",
    autoScrollEnabled: isAutoScrollOn(state),
    isLogoAndItemTypeBarFixed: isLogoAndItemTypeBarFixedSelector(state),
    isShippingForm: isShippingFormSelector(state),
    isAddressBarOpened: isAddressBarOpenedSelector(state),
    isPaymentKiosk: isPaymentKioskSelector(state),
    isReadOnlyMode: isMainBoard(state),
    isSearch: isSearchResult(state.router.location.pathname),
    isSearchPage: isSearchPageOpen(state),
    queryParams: state.uri.queryParams,
    isPhone: isPhoneSelector(state),
    isEcommerceSearchBarEnabled: isEcommerceSearchBarEnabled(state),
    justMadeReq: state.lazyLoad.justMadeReq,
    isAdvancedFilterOpen: isDesktopAndAdvancedFilterOpen(state),
    fetchingProducts: state.products.fetching,
    selectedCustomerType: getSelectedCustomerType(state)
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setCurrentProduct: (product) => dispatch(setProduct(product)),
    go: (uri) => dispatch(pushWithQueryParams(uri)),
    openCloseAdvancedFilter: () => dispatch(openCloseAdvancedFilter()),
    resetScrollPosition: () => dispatch(scrollTo(0)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(trackWindowScroll(ProductContainerRender));



// WEBPACK FOOTER //
// ./src/components/ProductContainerRender/ProductContainerRender.jsx